import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Station, StationMap, StationItem} from "../models/station";
import {of} from "rxjs/observable/of";
import { encode } from 'punycode';
import { getFileNameFromResponseContentDisposition, checkIfTruncated, saveFile } from './utils/file-download-helper';

@Injectable()
export class StationService {

  AP_API_URL = environment.serverUrl + "api/1/stations";

  constructor(public httpClient: HttpClient) {
  }

  /**
   * Return an observable of lists of station to be displayed on the map
   */

  getStationsByGroups(): Observable<any> {
    return this.httpClient.get<any>(environment.serverUrl + "api/1/findbikes?isUser=false")
  }

  getFormattedUrl(pageIndex : number, itemPerPage : number, filters : Map<string, string>, criterias : Map<string, boolean>) {
    let offset = ((pageIndex-1)*itemPerPage); // records offset to display the specific range

    let url = this.AP_API_URL + "?pagination=" + offset + "-" + itemPerPage + "&sorts=";

    if (criterias.size == 0) { // if no sorts criterias => sort by id
      url += "station.name asc";
    } else {
      Array.from(criterias.keys()).forEach( c => url += c + (criterias.get(c) === true ? " asc" : " desc") + "," );
      url = url.substring(0, url.length - 1);
    }

    if (filters != undefined) {

      let filtersAsString = JSON.stringify(filters, (key, value) => {
        if (value !== null && value != undefined && value != "") return value
      });

      if (filtersAsString.length > 2) {
        url += "&filters=" + filtersAsString;
      }
    }

    return url;
  }

  getPaginatedFilteredSortedStations(pageIndex : number, itemPerPage : number, filters : Map<string, string>, criterias : Map<string, boolean>): Observable<any> {
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias);
    
    return this.httpClient.get<StationItem[]>(encodeURI(url), {observe:"response"}).map(response => {
      return {
        headers: response.headers,
        res: <StationItem[]>response.body
      }
    }
    );
  }

  downloadXLSFile(pageIndex: number, itemPerPage: number, filters: Map<string, any>, criterias: Map<string, boolean>): any {
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias);
    return this.httpClient.get<any>(encodeURI(url), {
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob' as 'json',
      observe: 'response'
    }).map((response) => {
      const fileName = getFileNameFromResponseContentDisposition(response, "stations.xls");
      const isTruncated = checkIfTruncated(response);
      saveFile(response.body.slice(), fileName);
      return isTruncated;
    });
  }

  getStations(station: StationItem): Observable<Station> {
    return this.httpClient.get<Station>(this.AP_API_URL + "/" + station.id);
  }

  create(station: StationItem): Observable<Station> {
    return this.httpClient.post<Station>(this.AP_API_URL, station);
  }
  get(stationId : number) : Observable<Station> {
    return this.httpClient.get<Station>(encodeURI(this.AP_API_URL + "/" + stationId));
  }

  update(station: StationItem): Observable<StationItem> {
    return this.httpClient.put<StationItem>(`${this.AP_API_URL}/${station.id}`, station);
  }

  delete(station: Station): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${this.AP_API_URL}/${station.id}`);
  }

  getStationsFromGroup(groupId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.AP_API_URL}?pagination=0-100&groupId=${groupId}`)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/station.service.ts